import {ValidatorInterface} from "./ValidatorInterface";
import { AbstractValidator, ValidatorObject } from "./AbstractValidator";
import isEmpty from "lodash/isEmpty";

interface UniqueValidatorObject extends ValidatorObject {
	values: string[];
}

/**
 * Validator that checks if the value is unique.
 */
export class IsUnique extends AbstractValidator implements ValidatorInterface {
	declare readonly value: string;
	private readonly values: string[];

	/**
	 * Constructor.
	 *
	 * @param {UniqueValidatorObject} options
	 */
	constructor( options: UniqueValidatorObject ) {
		super( options );

		this.values = options.values;
	}

	/**
	 * @inheritDoc
	 */
	getMessage(): string {
		return super.getCustomMessage() ?? `This must be unique.`;
	}

	/**
	 * @inheritDoc
	 */
	isValid(): boolean {
		if ( isEmpty( this.values ) ) {
			return true;
		}

		return ! this.values.includes( this.value );
	}
}
